import React from "react";

export default function HomeSkeleton() {
  return (
    <div className="min-h-screen bg-[#f8f9ff] antialiased pb-4 animate-pulse">
      <div className="max-w-4xl mx-auto px-4 pt-6 md:pt-10">
        <div className="mb-6 space-y-2">
          <div className="h-4 bg-gray-200 rounded w-24"></div>
          <div className="h-8 bg-gray-200 rounded w-48"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl p-5 md:p-6 border border-gray-100 flex flex-col justify-between h-[230px]">
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <div className="h-4 bg-gray-200 rounded w-24"></div>
                <div className="h-5 bg-gray-200 rounded-full w-20"></div>
              </div>
              <div className="h-8 bg-gray-200 rounded w-36"></div>
              <div className="space-y-2 pt-2">
                <div className="h-3 bg-gray-200 rounded w-28"></div>
                <div className="h-2 bg-gray-200 rounded w-full"></div>
              </div>
            </div>
            <div className="h-11 bg-gray-200 rounded-xl w-full mt-4"></div>
          </div>

          <div className="space-y-4 flex flex-col justify-between">
            <div className="bg-white rounded-2xl p-5 border border-gray-100 flex-1 flex flex-col justify-between min-h-[170px]">
              <div className="space-y-3">
                <div className="h-3 bg-gray-200 rounded w-24"></div>
                <div className="h-5 bg-gray-200 rounded w-3/4"></div>
              </div>
              <div className="border-t border-gray-100 pt-4 flex justify-between">
                <div className="space-y-1">
                  <div className="h-4 bg-gray-200 rounded w-20"></div>
                  <div className="h-3 bg-gray-200 rounded w-16"></div>
                </div>
                <div className="space-y-1">
                  <div className="h-4 bg-gray-200 rounded w-20"></div>
                  <div className="h-3 bg-gray-200 rounded w-16"></div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white rounded-xl p-4 border border-gray-100 h-20 space-y-2">
                <div className="h-3 bg-gray-200 rounded w-16"></div>
                <div className="h-4 bg-gray-200 rounded w-24"></div>
              </div>
              <div className="bg-white rounded-xl p-4 border border-gray-100 h-20 space-y-2">
                <div className="h-3 bg-gray-200 rounded w-16"></div>
                <div className="h-4 bg-gray-200 rounded w-24"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 space-y-4">
          <div className="flex justify-between items-center">
            <div className="h-5 bg-gray-200 rounded w-28"></div>
          </div>
          <div className="space-y-3">
            {[1, 2, 3].map((n) => (
              <div
                key={n}
                className="bg-white rounded-xl p-4 border border-gray-100 h-16 flex items-center justify-between"
              >
                <div className="space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-32"></div>
                  <div className="h-3 bg-gray-200 rounded w-20"></div>
                </div>
                <div className="h-5 bg-gray-200 rounded w-16"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
